import classnames from 'classnames';
import React, { FC } from 'react';
import {
  isMobileFolder,
  isMyUploadsFolder,
  isPurchasedFolder,
  isWixVideoLibrary,
  isWixVideoLibraryLink,
} from '../../../../utils/media-manager-sdk/items';
import { StatusAlertFilledSmall } from '../../WixIcons';
import styles from './FolderThumbnail.scss';
import { IFolderThumbnail } from './FolderThumbnail.types';

export const FolderThumbnail: FC<IFolderThumbnail> = ({
  folder,
  small = false,
  dark = false,
  className,
  dataHook = 'folder-thumbnail',
  width,
  height,
  isFilesImporterNewLayout,
}) => {
  const isMyUploads = isMyUploadsFolder(folder);
  const isWixVideo = isWixVideoLibraryLink(folder) || isWixVideoLibrary(folder);
  return (
    <div
      className={classnames(
        styles.thumbnail,
        {
          [styles.mobile]: folder && isMobileFolder(folder),
          [styles.purchased]: folder && isPurchasedFolder(folder),
          [styles.dark]: dark,
          [styles.small]: small,
          [styles.newLayoutThumbnail]: folder && isFilesImporterNewLayout && !isWixVideo,
          [styles.myUploads]: folder && isMyUploads,
          [styles.wixVideoLink]: folder && isWixVideo,
          [styles.oldColor]: !window.isNewColorsBrandingEnabled,
        },
        className,
      )}
      data-hook={dataHook}
      style={{ width, height }}
    >
      {isMyUploads && (
        <div className={styles.myUploadsAlertIcon}>
          <StatusAlertFilledSmall size="22px" />
        </div>
      )}
    </div>
  );
};
